module.exports = __webpack_public_path__ + "static/img/pay.15ee28c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/newWx/pay.png
// module id = ZfRa
// module chunks = 0